import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
@JsonObject('model.QBserv')
export class QBServ extends AbstractModel {

    @JsonProperty(String, 'id')
    id: string;

    @JsonProperty(String, 'fullyQualifiedName')
    fullyQualifiedName?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'description')
    description?: string;
}
